import * as React from "react";
import { Constants } from "../../../@types/Constants";
import ErrorMessageAlert from "../ErrorMessageAlert/ErrorMessageAlert";
import {
  container,
  disclaimer,
  formText,
  travelPassInfo,
} from "./SignupForm.module.scss";

export const Container: React.FC<any> = (props) => {
  return <div className={container}>{props.children}</div>;
};
export const Disclaimer: React.FC<any> = (props) => {
  return <div className={disclaimer}>{props.children}</div>;
};
export const FormText: React.FC<any> = (props) => {
  return <div className={formText}>{props.children}</div>;
};

export const TrackErrorMessage: React.FC<{ message: string; field: string }> = (
  props
) => {
  const trackMessage =
    props.message && typeof props.message !== undefined
      ? `${props.message} - ${props.field}`
      : "";
  return (
    <ErrorMessageAlert
      errorType={Constants.ERRORSTYPE.TRAVELPASS}
      errorSubType={Constants.ERRORSSUBTYPE.TRAVELPASS.SIGNUP}
      message={trackMessage}
    >
      {props.message}
    </ErrorMessageAlert>
  );
};

export const TravelPassInfo: React.FC<any> = (props) => {
  return <div className={travelPassInfo}>{props.children}</div>;
};
